import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@environments/environment';
import { AppModule } from './app/app.module';
import { registerLicense } from '@syncfusion/ej2-base';

// fetch(
//   `${environment.apiVersionUrl}Company/getAzureKey?keyName=SyncfusionLicenseKey`
// ).then(function (response) {
//   if (response.ok) {
//     response.text().then(function (res) {
//       registerLicense(res);
//     });
//   }
// });

registerLicense(environment.SyncfusionLicenseKey);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
